import { Link } from 'react-router-dom';
import { categories, siteInfo } from '@/mocks/siteData';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6">
        <div className="py-12 md:py-16">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
            <div className="md:col-span-1">
              <h3 className="text-lg font-bold font-heading text-background-50 mb-4">
                福利姬完全指南
              </h3>
              <p className="text-sm text-background-400 leading-relaxed">
                {siteInfo.description}
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold font-heading text-background-50 mb-4">
                内容分类
              </h4>
              <ul className="space-y-2">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-background-100 transition-colors"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold font-heading text-background-50 mb-4">
                快速链接
              </h4>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/"
                    className="text-sm text-background-400 hover:text-background-100 transition-colors"
                  >
                    首页
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-background-400 hover:text-background-100 transition-colors"
                  >
                    关于我们
                  </Link>
                </li>
                <li>
                  <Link
                    to="/category/origin-development"
                    className="text-sm text-background-400 hover:text-background-100 transition-colors"
                  >
                    起源与发展
                  </Link>
                </li>
                <li>
                  <Link
                    to="/category/industry-news"
                    className="text-sm text-background-400 hover:text-background-100 transition-colors"
                  >
                    行业动态
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold font-heading text-background-50 mb-4">
                联系我们
              </h4>
              <ul className="space-y-2">
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <i className="ri-mail-line text-base w-5 h-5 flex items-center justify-center"></i>
                  <span>{siteInfo.contact.email}</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <i className="ri-wechat-line text-base w-5 h-5 flex items-center justify-center"></i>
                  <span>微信：{siteInfo.contact.wechat}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-background-700/50 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有 | 本站内容仅供学习参考，不构成任何建议
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-background-500">关注我们</span>
            <a href="#" className="w-8 h-8 flex items-center justify-center text-background-400 hover:text-background-100 transition-colors" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center text-background-400 hover:text-background-100 transition-colors" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center text-background-400 hover:text-background-100 transition-colors" aria-label="RSS">
              <i className="ri-rss-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}